import AjaxRequest from './AjaxRequest';

export default class AuthorizeNet
{
    getToken(data) {
        return new AjaxRequest().post(`authorize_net/get_token`, data);
    }
}
